import * as types from '../constants/actionTypes';
import * as companyActions from "../graphql/actions/company";
import {addNotification as notify} from 'reapop';
import l10n from "../l10n/localization";
import * as selected from "./selected";
import * as creationActions from "./creation";

export function fetchCompanies(force = false) {
    return dispatch => {
        dispatch(loading());
        companyActions.getCompanies(
            function(response) {
                dispatch(receiveCompanies(response.data.companies));
            },
            function(error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            force
        );
    }
}

export function add(company, selectNewItem = false) {
    return dispatch => {
        dispatch(loading());
        dispatch(saving(company));
        companyActions.add(
            function (response) {
                if (selectNewItem === true) {
                    dispatch(selected.selectedCompany(response.data.createCompany))
                }

                dispatch(saved(response.data.createCompany));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedCompany(response.data.createCompany));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            company
        );
    };
}


export function edit(company) {
    let id = company.id;
    delete company.id;
    delete company.__typename;
    delete company.countryName;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(company));
        companyActions.edit(
            function (response) {
                dispatch(saved(response.data.editCompany));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            company
        );
    };
}


export function loading() {
    return {
        type: types.LOADING_COMPANY
    };
}


export function saving(company) {
    return {
        type: types.SAVING_COMPANY,
        payload: company
    };
}

export function saved(company) {
    return {
        type: types.SAVED_COMPANY,
        payload: company
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_COMPANIES,
    };
}

export function receiveCompanies(data) {
    return {
        type: types.RECEIVED_COMPANIES,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}



// WEBPACK FOOTER //
// ./src/actions/company.js